
<script>
import { defineComponent, inject, computed, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import AnimationLink from '@project/components/AnimationLink.vue'
import { useRoute } from 'vue-router'
import Scroller from '@kit/utils/Scroller'
import { inBrowser } from '@kit/utils/EnvironmentHelper'
import { sleep } from '@kit/utils/Sleep'


export default defineComponent({
  name: "About",
  setup() {

    const smoothScroll = inject("smoothScroll")
    const hydrate = inject("hydrate")
    const route = useRoute()
    let scrollInMotion = false
    let scrollCache = null

    const section = computed(() => {
      return route.params.section
    })

    const _performScroll = async(id) => {
      await nextTick()    
      const el = document.getElementById(id)
      if(el) {
        smoothScroll({
          scrollTo: el,
          offset:-50
        })
      }
      await sleep(500)
    }

    const performScroll = async(id) => {

      if(inBrowser) {
        if(scrollInMotion) {
          scrollCache = id
        } else {
          scrollInMotion = true
          await _performScroll(id)
          scrollInMotion = false
          if(scrollCache) {
            const next = scrollCache
            scrollCache = null 
            performScroll(next)
          }
        }
      }
    }

    watch(section, (newVal) => {
      if(newVal) {
        performScroll(section.value)
      }
    })


    const { prefetch } = hydrate({
      metadata(meta) {
        meta.addTitle("RVIHA | About")
      }
    })

    return { section }
  },
  components: {
    AnimationLink
  }
});
</script>

<template>

<div class="sub-banner">
  <div class="container _2-down w-container">
    <div class="sub-banner-info">
      <h1 class="top-title white big">About Us <strong>
          <br />
        </strong>
      </h1>
    </div>
  </div>
</div>

  <div class="section wf-section">
    <div class="container w-container">
      <div>
        <div class="row-flex verical w-row">
          <div class="w-col w-col-6 w-col-stack">
            <div>
              <img src="/cms-static-assets/2023/05/603667503325960dad61c5bc_119358273_m_r.jpg" width="750" alt="" class="shape-image" />
            </div>
          </div>
          <div class="w-col w-col-6 w-col-stack">
            <div class="padding-right">
              <div class="top-title-wrapper">
                <h1 class="top-title">Our Mission <strong>
                    <br />
                  </strong>
                </h1>
                <h1 class="top-title abolute">About</h1>
              </div>
              <div>
                <p>The Mission of the Round Valley Indian Housing Authority is to create affordable housing opportunities and safe, viable communities that enhance the quality of life for low-and moderate income tribal members: and, if tribal needs are met, for other Native American families residing within its jurisdiction. In the best interests of the Round Valley Tribes and the Round Valley Indian Housing Authority, every effort will be made to see that tribal members obtain economic benefits through Indian preference in procurement, contracting and employment. <br />
                </p>
              </div>
              <div class="top-margin half">
                <AnimationLink 
                  class="navlink for-button blue w-inline-block" 
                  type="router-link" 
                  outerColor="#cccccc"
                  innerColor="#ff2600"
                  to="/about/services">View Our Services
                </AnimationLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="services" class="section gray wf-section">
    <div class="container w-container">
      <div>
        <div class="top-title-wrapper">
          <h1 class="top-title">What we offer <strong>
              <br />
            </strong>
          </h1>
          <h1 class="top-title abolute _75-percent">services</h1>
          <AnimationLink 
            class="navlink for-button blue _0 w-inline-block" 
            type="router-link" 
            outerColor="#cccccc"
            innerColor="#ff2600"
            to="/contact-us">Contact Us
          </AnimationLink>
        </div>
        <div>
          <div class="w-row">
            <div class="w-col w-col-6">
              <div class="team-wrapper">
                <div class="services-photo"></div>
                <div class="team-content">
                  <h1 class="service-title team">New Community Living <br />
                  </h1>
                  <p class="job-title dark">Maybe we can put a paragraph here about how this helps the community and what you do exactly. The Mission of the Round Valley Indian Housing Authority is to create affordable housing opportunities.</p>
                </div>
              </div>
            </div>
            <div class="w-col w-col-6">
              <div class="team-wrapper">
                <div class="services-photo _2"></div>
                <div class="team-content">
                  <h1 class="service-title team">New Constructions <br />
                  </h1>
                  <p class="job-title dark">Maybe we can put a paragraph here about how this helps the community and what you do exactly. The Mission of the Round Valley Indian Housing Authority is to create affordable housing opportunities.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>